module.exports = __webpack_public_path__ + "img/important_devices.21ae657b.svg";